import classnames from "classnames";
import CustomImage from "../../../core/CustomImage/CustomImage";
import useIsMobile from "../../../hooks/useIsMobile";

const SingleImageBanner = ({
  title,
  description,
  image,
  maxWidth = "100%",
  className = "containerWidth",
  headingnfontSize = "2rem",
  color,
}) => {
  const isMobile = useIsMobile({ breakpoint: 768 });
  const style = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column-reverse" : "row",
      alignItems: isMobile ? "unset" : "center",
      gap: 30,
      paddingTop: 20,
    },
  };
  return (
    <div className={classnames(className)} style={style.container}>
      <div style={{ flex: 1 }}>
        <div
          className={classnames("heading")}
          style={{
            textAlign: "left",
            fontSize: headingnfontSize,
            color: color,
          }}
        >
          {title}
        </div>
        <div
          className={classnames("subheading")}
          style={{
            textAlign: "left",
            margin: "unset",
            paddingBottom: "20px",
            color: color,
          }}
        >
          {description}
        </div>
      </div>
      <CustomImage
        src={image}
        width="100%"
        className={classnames("bannerImg")}
        style={{ maxWidth: maxWidth, margin: isMobile ? "auto" : "unset" }}
      />
    </div>
  );
};
export default SingleImageBanner;
